// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"datagridheader_headerBox__1lbYY","filterBtn":"datagridheader_filterBtn__2s5Vb","activeFilterIndicator":"datagridheader_activeFilterIndicator__1ivNK"};